import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PlatformBannerRow {
  id: string;
  title: string;
  body: string | null;
  cta_text: string | null;
  cta_url: string | null;
  severity: "info" | "success" | "warning";
}

/**
 * Lista banners de plataforma ativos para exibição no Public.
 * RLS já restringe a `is_active AND now() BETWEEN starts_at AND ends_at`,
 * então uma simples SELECT retorna só os banners vigentes.
 *
 * refetchInterval 5 min pra pegar expirações/ativações sem precisar
 * reload da página.
 */
export function usePlatformBanners() {
  return useQuery({
    queryKey: ["public", "platform-banners"] as const,
    refetchInterval: 5 * 60_000,
    refetchIntervalInBackground: true,
    staleTime: 60_000,
    queryFn: async (): Promise<PlatformBannerRow[]> => {
      const { data, error } = await supabase
        .from("platform_banners")
        .select("id,title,body,cta_text,cta_url,severity")
        .order("starts_at", { ascending: false });
      if (error) return [];
      return (data ?? []) as PlatformBannerRow[];
    },
  });
}
